<template>
  <v-dialog v-model="openMode" max-width="500px">
    <v-card class="permissions-dialog">
      <v-card-title class="dialog-header">
        <v-icon left class="ml-2" dark>mdi-shield-account</v-icon>
        הרשאות
      </v-card-title>

      <v-card-text>
        <v-container class="permissions-container">
          <v-card outlined class="permissions-card">
            <v-card-title class="permissions-title">
              <v-icon color="#0d2c6d" class="ml-2">mdi-key</v-icon>
              הגדרות הרשאות
            </v-card-title>
            <v-card-text>
              <div v-if="availablePermissions.length === 0" class="no-permissions">
                <v-icon small color="grey" class="ml-2">mdi-information-outline</v-icon>
                אין הרשאות זמינות להגדרה
              </div>

              <v-row v-for="permission in availablePermissions" :key="permission.key">
                <v-col cols="12">
                  <v-checkbox v-model="permissionsToEdit[permission.key]" color="#0d2c6d" hide-details
                    class="permission-checkbox">
                    <template v-slot:label>
                      <div class="permission-label">
                        <v-icon small color="#0d2c6d" class="ml-2">{{ permission.icon }}</v-icon>
                        {{ permission.label }}
                      </div>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="dialog-actions">
        <v-btn color="primary" class="save-button" @click="saveChanges" :loading="progressShow"
          :disabled="progressShow || availablePermissions.length === 0">
          <v-icon left>mdi-content-save</v-icon>
          שמור שינויים
        </v-btn>
        <v-btn color="grey lighten-3" @click="closeDelete">
          סגור
        </v-btn>
      </v-card-actions>
    </v-card>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
  </v-dialog>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'

// מקור אמת יחיד לתוויות ולאייקונים של ההרשאות.
// המפתחות חייבים להיות תואמים לשדות ב-extenPermissionsSchema בצד השרת.
// הוספת הרשאה חדשה בסכמה = הוספת שורה אחת כאן.
const PERMISSIONS_META = {
  confRoom: { label: 'חדר ועידה', icon: 'mdi-account-group' },
  playSubscribersNumbers: { label: 'השמעת פרטי החברים בקבוצה', icon: 'mdi-playlist-play' },
  all_can_record_private: { label: 'הקלטה פרטית לכל המשתמשים', icon: 'mdi-microphone' },
  all_can_record_public: { label: 'הקלטה ציבורית לכל המשתמשים', icon: 'mdi-microphone-outline' },
  share_record: { label: 'שיתוף הקלטות', icon: 'mdi-share-variant' },
  like: { label: 'לייקים', icon: 'mdi-thumb-up' },
  surveys: { label: 'סקרים', icon: 'mdi-poll' },
  aiAssistant: { label: 'עוזר קולי (AI) בשלוחה 3', icon: 'mdi-robot-outline' },
};

export default {
  props: {
    ivr: Object,               // המערכת של היוזר שאותה עורכים
    agentPermissions: { type: Object, default: () => ({}) },
    value: { type: Boolean, default: false },
  },
  components: {
    SnackBar,
  },
  data: () => ({
    progressShow: false,
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
    permissionsToEdit: {},
    sendCall: false,
  }),

  methods: {
    async saveChanges() {
      try {
        this.progressShow = true;
        let token = localStorage.getItem("token");

        // שולחים רק את המפתחות שהסוכן באמת מורשה לגעת בהם
        const permissionsObj = {};
        this.availablePermissions.forEach((permission) => {
          permissionsObj[permission.key] = this.permissionsToEdit[permission.key] === true;
        });

        const permissionsJSON = JSON.stringify({
          permissionsObj: permissionsObj,
          ivrLineNumber: this.ivr.line_number
        });

        const api = process.env.VUE_APP_BASE_URL + "/agent_api/change_ivr_permissions";
        const res = await fetch(api, ApiServices.requestOptions("POST", permissionsJSON, token));
        await res.json();
        if (res.status >= 400) {
          this.showSnackBar("שגיאה בשמירת ההרשאות ", "red");
          this.progressShow = false;
        } else if (res.status === 200) {
          this.progressShow = false;
          this.$emit("ivrPermissionsChanged", permissionsObj);
          this.showSnackBar("השינויים נשמרו בהצלחה!", "green");
          this.openMode = false;
        }
      } catch (error) {
        this.progressShow = false;
        this.showSnackBar("שגיאה בשמירת השינויים : " + error, "red");
      }
    },
    initPermissions() {
      const current = (this.ivr && this.ivr.exten_permissions) || {};
      const initial = {};
      this.availablePermissions.forEach((permission) => {

        initial[permission.key] = current[permission.key] === true;
      });
      this.permissionsToEdit = initial;
    },
    closeDelete() {
      this.openMode = false;
    },
    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true;
    },
  },
  computed: {
    openMode: {
      get() {
        return this.value;
      },
      set(v) {
        return this.$emit('input', v);
      }
    },
    // רק הרשאות שאצל הסוכן מוגדרות true מוצגות ליוזר
    availablePermissions() {
      console.log(333);

      return Object.keys(PERMISSIONS_META)
        .filter((key) => this.agentPermissions[key] === true)
        .map((key) => ({
          key: key,
          label: PERMISSIONS_META[key].label,
          icon: PERMISSIONS_META[key].icon,
        }));
    },
  },
  watch: {
    // הדיאלוג נשאר mounted בין פתיחות – מאתחלים בכל פתיחה
    value(isOpen) {
      if (isOpen) {
        this.initPermissions();
      }
    },
  },
  mounted() {
    this.initPermissions();
  },
}
</script>

<style scoped>
.permissions-dialog {
  border-radius: 12px;
  overflow: hidden;
  direction: rtl;
  font-family: 'Heebo', sans-serif;
}

.dialog-header {
  background: linear-gradient(135deg, #0d2c6d 0%, #1a4ba5 100%);
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  padding: 16px;
}

.permissions-container {
  padding: 16px 0;
}

.permissions-card {
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.permissions-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.permissions-title {
  font-size: 16px;
  font-weight: 600;
  color: #0d2c6d;
  padding: 12px 16px;
  background-color: rgba(13, 44, 109, 0.05);
}

.permission-checkbox {
  margin-bottom: 8px;
}

.permission-label {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333;
}

.no-permissions {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #777;
  padding: 8px 0;
}

.dialog-actions {
  padding: 16px;
  display: flex;
  justify-content: flex-start;
}

.save-button {
  background: linear-gradient(135deg, #ffb91a 0%, #ffd166 100%) !important;
  color: #0d2c6d !important;
  font-weight: 600;
  margin-left: 16px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.save-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .dialog-actions {
    flex-direction: column;
  }

  .save-button {
    margin-left: 0;
    margin-bottom: 8px;
    width: 100%;
  }
}
</style>